import WorkflowFooter from './WorkflowFooter.vue';
import WorkflowNavigation from './WorkflowNavigation.vue';

export { WorkflowFooter, WorkflowNavigation };
